import {TasksDesktopView} from "src/components/views/tasks/desktop/TasksDesktopView.tsx";
import {TaskQueryParams} from "src/components/views/tasks/types.ts";
import {TaskSourceRef} from "src/api/generated/tasks/taskSource/taskSourceRef.ts";
import {RefreshableElementRef} from "src/utils/useRefreshRef.ts";
import {TaskView} from "src/api/generated/postgres/db/types/tasks/tables/taskView.ts";

export interface TasksViewProps {
	refreshRef?: RefreshableElementRef;
	onTaskCompleted?: (task: TaskView) => void;
	onTaskCompletionReverted?: (task: TaskView) => void;
	taskQueryParams: TaskQueryParams;
	taskSourceRef?: TaskSourceRef;
	showCanBeStarted?: boolean;
	showIsInSchedulePlanning?: boolean;
	showTaskSourceInfo?: boolean;
	showAssignedTo?: boolean;
	showResponsiblePerson?: boolean;
	showGanttButton?: boolean;
	usePagination?: boolean;
}

export const TasksView = (props: TasksViewProps) => {
	return <TasksDesktopView {...props} />;
	//
	// const isMobile = useMediaQueryBreakpointDown("md");
	// if (isMobile) return <TasksMobileView {...props} />;
	// else return <TasksDesktopView {...props} />;
};
